import React from "react";
import format from "date-fns/format";
import { es, enUS } from "date-fns/locale";

import I24ChevronRight from "assets/icons/I24ChevronRight";
import I24ChevronLeft from "assets/icons/I24ChevronLeft";

import styleConst from "constants/style";

import { Arrows, Container, Title, ArrowContainer } from "./styles";

type Props = {
  date: Date;
  onNextClick: () => void;
  onPrevClick: () => void;
  fontSize?: number;
  locale?: any;
};

const Header: React.FC<Props> = ({
  date,
  onNextClick,
  onPrevClick,
  fontSize = 18,
  locale,
}) => {
  let dateFnsLocale;
  if (typeof locale === "string") {
    if (locale.startsWith("es")) {
      dateFnsLocale = es;
    } else {
      dateFnsLocale = enUS;
    }
  } else if (locale) {
    dateFnsLocale = locale;
  }
  let formattedMonth = format(
    date,
    "MMMM yyyy",
    dateFnsLocale ? { locale: dateFnsLocale } : undefined
  );
  // Capitalizar la primera letra del mes
  formattedMonth = formattedMonth.charAt(0).toUpperCase() + formattedMonth.slice(1);
  return (
    <Container>
      <Title fontSize={fontSize}>{formattedMonth}</Title>
      <Arrows>
        <ArrowContainer onClick={onPrevClick}>
          <I24ChevronLeft
            color={styleConst.colors.black}
            width={16}
            height={16}
          />
        </ArrowContainer>
        <ArrowContainer onClick={onNextClick}>
          <I24ChevronRight
            color={styleConst.colors.black}
            width={16}
            height={16}
          />
        </ArrowContainer>
      </Arrows>
    </Container>
  );
};

export default React.memo(Header);
